export default {
    removal: {
        action: 'Remove from Social Sharing',
        title: 'Remove from Social Sharing?',
        chooseAction: 'Remove this item?',
        description: 'This removes the item from Social Sharing and its collections. Your original videos and video cards in MarketScale Studio stay unchanged.',
        linkedInPost: 'Your published LinkedIn post also stays unchanged.',
        collectionAction: 'Remove from collection',
        collectionDescription: 'Keep this item in Social Sharing and other collections.',
        collectionLabel: 'Collection to remove from',
        collectionPlaceholder: 'Choose a collection',
        collectionSuccess: 'Removed from collection',
        collectionError: 'Could not remove from collection',
        success: 'Removed from Social Sharing',
        error: 'Could not remove from Social Sharing',
        retry: 'Please try again.',
        cancel: 'Cancel',
        close: 'Close',
        untitled: 'Untitled',
    },
};
